import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { Provider } from '../../../core/model/central/provider.model';
import { providerEntityMetadata } from './provider.entity';

@Injectable()
export class ProviderService extends EntityCollectionServiceBase<Provider> {
    constructor(private serviceElementsFactory: EntityCollectionServiceElementsFactory,
                private http: HttpClient) {
        super(providerEntityMetadata.entityName, serviceElementsFactory);
    }

    getEstimatedAppointmentsAffected(provider): Observable<number> {
        return this.http.get<any>(`servlets/providers/${provider.providerId}/${provider.strategyId}/estimated/`,
            {
                headers: {'Content-Type': 'application/json'}
            })
        .pipe(
            map(response => response.estimatedAffected)
        );
    }

    getProvidersByUserId(userId): Observable<any> {
        return this.http.get<any>(`servlets/providers/?userid=${userId}`,
            {
                headers: {'Content-Type': 'application/json'}
            })
            .pipe(
                map(response => response.providers)
            );
    }
}
